var React = require('react');

function MenuRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinejoin":"round","strokeWidth":"2","d":"M29.565 25H3.87h25.694zm.018-18H15.417h14.166zm-.018 9H10h19.565z"}));
}

MenuRight.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = MenuRight;

MenuRight.default = MenuRight;
